import React, {useEffect, useRef, useState} from 'react';
import {checkIfAllTutorialChaptersCompleted} from "../../configs/tutorial";
import {checkIfHasIncompleteQuests, checkIfHasReminderQuests} from "../../configs/quests";
import {useDispatch, useSelector} from 'react-redux';
import './MainMenu.css';
import {FACTION_CONFIGS, FACTION_CONFIGS_IMPLEMENTED} from '../../configs/factions';
import {getFactionImagePath} from '../../utils/factions/getFactionImagePath';
import {LoadedImage} from "../EmblaCarousel/FactionsCarousel";
import PageButton from '../elements/PageButton/PageButton';
import VersionLabel from '../VersionLabel/VersionLabel';
import MainMenuSocialLinks from './MainMenuSocialLinks/MainMenuSocialLinks';
import {usePageAnalytics} from '../../hooks/analytics/usePageAnalytics';
import UserHeader from "../UserHeader/UserHeader";
import MenuDemoGame from "./MenuDemoGame";
import {DESKTOP_MIN_WIDTH} from "../../constants/visuals";
import {useOpaqueOnMount} from "../../hooks/visuals/useOpaqueOnMount";
import {useDriftingSearchHint} from "../../hooks/other/useDriftingSearchHint";
import RankedMatchButton from "../RankedMatchButton/RankedMatchButton";
import {SHOP_TAB_ICON_PATHS} from "../pages/ShopPage/ShopPage";
import {useIsDailyDoubleRewardAvailable} from "../../hooks/rewards/useIsDailyDoubleRewardAvailable";
import DailyLoginRewardModal from "../Modals/DailyLoginRewardModal/DailyLoginRewardModal";
import PartnerReferalRewardModal from "../Modals/PartnerReferalRewardModal/PartnerReferalRewardModal";
import LoginPromoRewardModal from "../Modals/LoginPromoRewardModal/LoginPromoRewardModal";
import QuestsReminderModal from "../Modals/QuestsReminderModal/QuestsReminderModal";
import LoginRequiredModal from "../Modals/LoginRequiredModal/LoginRequiredModal";
import {LOGIN_REQUIRED_REASONS} from "../../configs/guestProfile";
import RatingCrystalsRewardModal from "../Modals/RatingCrystalsRewardModal/RatingCrystalsRewardModal";
import RatingCrystalsInfoModal from "../Modals/RatingCrystalsInfoModal/RatingCrystalsInfoModal";
import {
  checkIfRatingCrystalsIntroPending,
  rememberRatingCrystalsIntroShown,
} from "../../utils/rating/ratingCrystalsIntroStorage";
import {applyFriendReferalRewardsClaim, setDailyLoginRewardClaimed} from "../../redux/actions";
import {getGameDayKey} from "../../utils/date/getGameDayKey";
import {selectServerTimeDelta} from "../../redux/reducers/privateStateReducer/selectors";
import {API_BASE} from "../../utils/apiConfig";
import AppInstallPromoModal from '../Modals/AppInstallPromoModal/AppInstallPromoModal';
import AppInstallRewardModal from '../Modals/AppInstallRewardModal/AppInstallRewardModal';
import {APP_INSTALL_REWARD_CHEST_ID} from '../../configs/appInstall';
import {
  checkIfAppInstallAvailable,
  promptAppInstall,
  subscribeToAppInstallAvailability,
} from '../../utils/pwa/appInstall';
import {requestAppInstallReward} from '../../utils/pwa/requestAppInstallReward';
import {sendPageEvent} from '../../analytics/gameAnalytics';
import {getDeviceKind} from '../../utils/device/getDeviceKind';
import {isRunningAsInstalledPwa} from '../../utils/fullscreen';
import {applyAppInstallRewardGranted} from '../../redux/actions';
import {
  checkIfQuestsReminderDue,
  checkIfQuestsReminderIntroPending,
  rememberQuestsReminderIntroShown,
  rememberQuestsReminderShown,
} from "../../utils/quests/questsReminderStorage";
import BotMatchPromoModal from "../Modals/BotMatchPromoModal/BotMatchPromoModal";
import OnlineMatchPromoModal from "../Modals/OnlineMatchPromoModal/OnlineMatchPromoModal";
import RankedMatchPromoModal from "../Modals/RankedMatchPromoModal/RankedMatchPromoModal";
import {resolveBotMatchPromoReason} from "../../utils/menuPromo/resolveBotMatchPromoReason";
import {resolveOnlineMatchPromoReason} from "../../utils/menuPromo/resolveOnlineMatchPromoReason";
import {resolveRankedMatchPromoReason} from "../../utils/menuPromo/resolveRankedMatchPromoReason";
import {
  checkIfBotMatchPromoDue,
  checkIfBotMatchPromoPending,
  clearBotMatchPromoPending,
  rememberBotMatchPromoShown,
} from "../../utils/menuPromo/botMatchPromoStorage";
import {
  checkIfOnlineMatchPromoDue,
  checkIfOnlineMatchPromoEverShown,
  rememberOnlineMatchPromoShown,
} from "../../utils/menuPromo/onlineMatchPromoStorage";
import {
  checkIfRankedMatchPromoDue,
  checkIfRankedMatchPromoEverShown,
  rememberRankedMatchPromoShown,
} from "../../utils/menuPromo/rankedMatchPromoStorage";
import {getOnlineMatchQuestReward} from "../../utils/quests/getOnlineMatchQuestReward";
import {getLocalMatchQuestReward} from "../../utils/quests/getLocalMatchQuestReward";
import RankSkinsNewsModal from "../Modals/RankSkinsNewsModal/RankSkinsNewsModal";
import {checkIfRankSkinsNewsDue} from "../../utils/menuPromo/checkIfRankSkinsNewsDue";
import {checkIfRankSkinsNewsOpenable} from "../../utils/menuPromo/checkIfRankSkinsNewsOpenable";
import {markRankSkinsNewsSeen} from "../../utils/menuPromo/markRankSkinsNewsSeen";
import {setRankSkinsNewsSeen} from "../../redux/actions";
import AiMatchMenuButton from "./AiMatchMenuButton/AiMatchMenuButton";
import AiMatchPromoModal from "../Modals/AiMatchPromoModal/AiMatchPromoModal";
import {useAiPromoLobby} from "../../hooks/aiMatch/useAiPromoLobby";
import {checkIfAiPromoJoinable} from "../../utils/aiMatch/checkIfAiPromoJoinable";
import {checkIfAiMatchPromoOpenable} from "../../utils/menuPromo/checkIfAiMatchPromoOpenable";
import {checkIfAiMatchPromoDue, rememberAiMatchPromoShown} from "../../utils/menuPromo/aiMatchPromoStorage";
import AiMatchNewsModal from "../Modals/AiMatchNewsModal/AiMatchNewsModal";
import {checkIfAiMatchNewsDue} from "../../utils/menuPromo/checkIfAiMatchNewsDue";
import {checkIfAiMatchNewsOpenable} from "../../utils/menuPromo/checkIfAiMatchNewsOpenable";
import {markAiMatchNewsSeen} from "../../utils/menuPromo/markAiMatchNewsSeen";
import {setAiMatchNewsSeen} from "../../redux/actions";

const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH}px)`;

// Игровой день, в который последний раз проверяли акцию за вход. Живет в
// модуле (не в состоянии компонента и не в localStorage): ремаунты меню за тот
// же день повторную проверку не запускают, а перезагрузка страницы — сбрасывает
let lastLoginPromoCheckDayKey = null;

const HAS_DISCOUNTED_FACTIONS = FACTION_CONFIGS_IMPLEMENTED.some(
  (faction) => faction.originalPriceCrystals != null && faction.priceCrystals !== faction.originalPriceCrystals
);

// Подсказка под кнопкой "Обычный матч" — тот же дрифтующий механизм
// (useDriftingSearchHint), но со своим ключом хранения, локальным для меню
const ONLINE_SEARCH_HINT_STORAGE_KEY = 'mainMenuOnlineSearchHint';

function MainMenu({
  isIntroSlidesVisible,
                    onTutorial,
                    onNetworkGame,
                    onRankedGame,
                    onHotSeatGame,
                    // Приглашения новичку: готовый бой с ботами и сбор
                    // соперников в свое лобби (см. промо-модалки ниже)
                    onBotMatch,
                    onFindOpponents,
                    // «Битва с AI Claude Opus»: вход в лобби дня по его id
                    // (joinAiPromoLobby в App.js)
                    onAiMatch,
                    onInventory,
                    // Коллекция сразу на «Рейтинговых обличиях» (новость о них)
                    onInventoryRankSkins,
                    onProfile,
                    onGloryHall,
                    onBestCollections,
                    onSettings,
                    onRules,
                    onAcknowledgments,
                    onLicenseAgreement,
                    onPrivacyPolicy,
                    onContacts,
                    onAdmin,
                    onPartner,
                    onShop,
                    onGoToCrystals,
                    onOpenUserProfile,
                    onQuests,
                    onDevLogin,
                    onEmailAuthSuccess
                  }) {
  const auth = useSelector((state) => state.private.auth);
  // Гость: аккаунта еще нет, профиль моковый (см. configs/guestProfile.js).
  // Меню показывается целиком, но кнопки, которым нужен настоящий аккаунт,
  // вместо перехода открывают модалку входа со своим объяснением. Разделы без
  // личных данных — зал славы, лучшие коллекции, правила, настройки, подвал —
  // работают как есть.
  // Список обычных матчей гостю тоже открыт: модалку входа он получит там, при
  // попытке войти в лобби или создать свое (см. LobbyListPage)
  const isGuest = Boolean(auth.isGuest);
  const [loginRequiredReason, setLoginRequiredReason] = useState(null);
  const requireAuth = (handler, reason) => (isGuest
    ? () => setLoginRequiredReason(reason)
    : handler);
  // Поправка часов устройства до серверного времени (см. /api/time): все
  // расчеты игровых суток ниже идут по нему, а не по локальным часам
  const serverTimeDelta = useSelector(selectServerTimeDelta);
  const dispatch = useDispatch();

  // «Битва с AI Claude Opus»: лобби дня по опросу /api/ai-promo/today (null —
  // лобби нет). Видно и гостю: кнопка и промо-модалка ведут его в окно входа
  const {aiPromo, isAiPromoChecked} = useAiPromoLobby({userId: auth.id});

  // === Установка приложения (PWA) ===
  // Кнопка показывается только там, где браузер прислал beforeinstallprompt
  // (Chromium) и приложение еще не запущено как установленное. В iOS Safari
  // программной установки нет — там кнопки не будет (см. utils/pwa/appInstall)
  const [isAppInstallAvailable, setAppInstallAvailable] = useState(checkIfAppInstallAvailable);
  const [isAppInstallPromoOpen, setAppInstallPromoOpen] = useState(false);
  // Сундук, начисленный сервером за первый вход через приложение: пока он
  // здесь — показывается поздравительная модалка
  const [appInstallRewardChestId, setAppInstallRewardChestId] = useState(null);
  // Запрос этой награды еще в пути: будет ли поздравление, неизвестно, —
  // очередь модалок ниже по приоритету держим занятой, иначе какая-нибудь
  // из них успела бы открыться, а поздравление легло бы поверх нее
  const [isAppInstallRewardRequestPending, setAppInstallRewardRequestPending] = useState(false);

  useEffect(() => subscribeToAppInstallAvailability(
    () => setAppInstallAvailable(checkIfAppInstallAvailable())
  ), []);

  // Первый вход через установленное приложение: награду начисляет сервер, он
  // же и решает, первый ли это раз (флаг в профиле) — клиент лишь просит и
  // показывает результат. Гостю просить нечего: награда привязана к аккаунту
  useEffect(() => {
    if (isGuest || !auth.id || auth.appInstallRewardGrantedAt || !isRunningAsInstalledPwa()) {
      return;
    }

    let isActive = true;
    setAppInstallRewardRequestPending(true);
    // Запрос и метрики — в requestAppInstallReward (там же рекламная цель
    // первого входа через приложение). Ошибки он гасит сам и отдает null
    requestAppInstallReward({userId: auth.id}).then((data) => {
      if (!isActive) {
        return;
      }
      setAppInstallRewardRequestPending(false);
      if (!data) {
        return;
      }
      dispatch(applyAppInstallRewardGranted({grantedAt: data.grantedAt}));
      setAppInstallRewardChestId(data.chestId || APP_INSTALL_REWARD_CHEST_ID);
    });

    return () => {
      isActive = false;
      // Ответ этого запроса уже не применится (см. isActive) — очередь
      // он больше не держит; новый запуск эффекта поднимет флаг заново
      setAppInstallRewardRequestPending(false);
    };
  }, [isGuest, auth.id, auth.appInstallRewardGrantedAt, dispatch]);

  // Исход системного окна установки (accepted/dismissed/unavailable) — в
  // метрику: по нему видно, сколько игроков доходит от нашей модалки до
  // настоящей установки. Саму цель установки шлет событие браузера
  // appinstalled (см. utils/pwa/appInstall)
  const handleAppInstallClick = async () => {
    const outcome = await promptAppInstall();
    sendPageEvent('MainMenu', 'app_install_outcome', outcome, getDeviceKind());
  };

  const isAllTutorialCompleted = checkIfAllTutorialChaptersCompleted(auth.completedTutorialChapters);
  // Бейдж «Задания» на кнопке профиля: пока есть невыполненные ДОСТУПНЫЕ
  // задания (заблокированные, вроде сюжетной кампании, не считаются)
  const hasIncompleteQuests = checkIfHasIncompleteQuests({
    completedTutorialChapters: auth.completedTutorialChapters,
    completedQuests: auth.completedQuests,
  });
  // Напоминание-модалка зовёт только к тем заданиям, которые можно пойти и
  // выполнить: заблокированные и помеченные noReminder (подъём по лигам) не
  // в счёт — см. checkIfHasReminderQuests
  const hasReminderQuests = checkIfHasReminderQuests({
    completedTutorialChapters: auth.completedTutorialChapters,
    completedQuests: auth.completedQuests,
  });

  // Десктоп (>= 1024px): контент меню слева, справа — демо-партия ботов
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(DESKTOP_MEDIA_QUERY).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
    const handleChange = (event) => setIsDesktop(event.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  useEffect(() => {
    FACTION_CONFIGS.forEach((faction) => {
      const img = new Image();
      img.src = getFactionImagePath(faction.id);
    });
  }, []);

  // Иконки табов магазина — они же плейсхолдеры плашек товаров (LoadedImage
  // placeholderSrc) — прогреваем кэш браузера уже в главном меню, заранее до
  // открытия магазина: иначе заглушка догружается одновременно с самой
  // картинкой товара и не успевает резервировать место к первому кадру
  useEffect(() => {
    SHOP_TAB_ICON_PATHS.forEach((iconPath) => {
      const img = new Image();
      img.src = iconPath;
    });
  }, []);

  const onlineSearchingCount = useDriftingSearchHint(ONLINE_SEARCH_HINT_STORAGE_KEY, 4, 12, 1, 3);


  // Реферальная награда за регистрацию по ссылке партнера: показывается, пока
  // не забрана (hasReceivedPartnerReferalRewards === false). Скрывается
  // навсегда после клейма (флаг в сторе), на сессию — при закрытии оверлеем
  // или недоступности данных партнера
  const isPartnerReferalRewardPending = Boolean(auth.id)
    && Boolean(auth.linkedToPartnerReferalId)
    && auth.hasReceivedPartnerReferalRewards === false;
  const [isPartnerRewardModalHidden, setPartnerRewardModalHidden] = useState(false);
  const isPartnerRewardModalOpen = isPartnerReferalRewardPending && !isPartnerRewardModalHidden;

  // Награда «Пригласи друга» — та же механика; партнерская приоритетнее
  // (одновременно обе привязки не создаются, но страховка на порядок)
  const isFriendReferalRewardPending = Boolean(auth.id)
    && Boolean(auth.referredByUserId)
    && auth.hasReceivedFriendReferalRewards === false;
  const [isFriendRewardModalHidden, setFriendRewardModalHidden] = useState(false);
  const isFriendRewardModalOpen = isFriendReferalRewardPending
    && !isFriendRewardModalHidden
    && !isPartnerRewardModalOpen;

  // Акция за вход: проверяется на монтировании меню, но не чаще одного раза
  // за игровой день — день последней проверки живет в модуле (см.
  // lastLoginPromoCheckDayKey), то есть в оперативной памяти вкладки и
  // сбрасывается только перезагрузкой страницы. Приоритет ниже обеих
  // реферальных модалок — открывается лишь после того, как они закрыты
  const [isLoginPromoCheckStarted, setLoginPromoCheckStarted] = useState(false);
  const [isLoginPromoModalHidden, setLoginPromoModalHidden] = useState(false);
  useEffect(() => {
    if (!auth.id) return;
    const todayKey = getGameDayKey(Date.now() + serverTimeDelta);
    if (lastLoginPromoCheckDayKey === todayKey) return;
    lastLoginPromoCheckDayKey = todayKey;
    setLoginPromoCheckStarted(true);
  }, [auth.id, serverTimeDelta]);
  const isLoginPromoModalOpen = isLoginPromoCheckStarted
    && !isLoginPromoModalHidden
    && !isPartnerRewardModalOpen
    && !isFriendRewardModalOpen;

  // Ежедневная награда за вход: тот же принцип «дата получения не в текущих
  // игровых сутках», что и у x2 — границы суток у наград общие, поэтому
  // переиспользуется тот же хук. Модалки реферальных наград и акции за вход
  // приоритетнее: ежедневная открывается только после их закрытия (все три в
  // зависимостях — эффект перезапустится, когда предыдущие погаснут)
  const isDailyLoginRewardAvailable = useIsDailyDoubleRewardAvailable(auth.dailyLoginRewardClaimedAt);
  const [isDailyLoginRewardModalOpen, setDailyLoginRewardModalOpen] = useState(false);
  // Ежедневную награду в этом заходе уже показали и закрыли (забрали или
  // спрятали) — очередь модалок меню освободилась
  const [isDailyLoginRewardSeen, setDailyLoginRewardSeen] = useState(false);
  // Локальный профиль мог загружаться давно (например, вчера) и не знать, что
  // награду уже забрали с другого устройства. Поэтому перед показом модалки
  // один раз сверяемся с сервером легким /daily-login-reward/status (весь
  // профиль ради двух полей не перезапрашиваем) и обновляем стор; модалка
  // открывается только если после сверки награда все еще доступна
  const [isDailyLoginRewardChecked, setDailyLoginRewardChecked] = useState(false);
  // Вердикт сервера о доступности награды: true/false, либо null — сервер не
  // ответил (сеть). Сервер может только ЗАПРЕТИТЬ показ: он считает игровые
  // сутки по своим часам, а часы устройства бывают выставлены неверно
  const [isRewardAvailableOnServer, setRewardAvailableOnServer] = useState(null);
  useEffect(() => {
    if (!auth.id || !isDailyLoginRewardAvailable) return;
    if (isPartnerRewardModalOpen || isFriendRewardModalOpen || isLoginPromoModalOpen) return;

    if (isDailyLoginRewardChecked) {
      if (isRewardAvailableOnServer !== false) {
        setDailyLoginRewardModalOpen(true);
      }
      return;
    }

    let isCancelled = false;
    const verifyAndOpen = async () => {
      try {
        const res = await fetch(`${API_BASE}/daily-login-reward/status`, {credentials: 'include'});
        const data = await res.json().catch(() => ({}));
        if (res.ok && !isCancelled) {
          dispatch(setDailyLoginRewardClaimed(data.claimedAt ?? null, data.streak ?? 0));
          // Старые сборки сервера поля не отдают — тогда решение остается за
          // локальным расчетом, как раньше
          setRewardAvailableOnServer(typeof data.isAvailable === 'boolean' ? data.isAvailable : null);
        }
      } catch (e) {
        // Сеть недоступна — не запираем награду: ниже флаг все равно
        // выставится, и модалка откроется по локальным данным, как раньше
        console.error('Daily login reward status error', e);
      } finally {
        if (!isCancelled) {
          // Пересчет isDailyLoginRewardAvailable уже учтет свежую дату:
          // забрали сегодня — эффект перезапустится и выйдет по проверке выше
          setDailyLoginRewardChecked(true);
        }
      }
    };
    verifyAndOpen();

    return () => {
      isCancelled = true;
    };
  }, [
    auth.id, isDailyLoginRewardAvailable, isPartnerRewardModalOpen, isFriendRewardModalOpen,
    isLoginPromoModalOpen, isDailyLoginRewardChecked, isRewardAvailableOnServer, dispatch,
  ]);

  // Стрик, которым СТАНЕТ сегодняшнее получение (для подсветки дня в модалке):
  // вчера получал — продолжение серии, любой пропуск — серия заново
  const isYesterdayClaim = getGameDayKey(auth.dailyLoginRewardClaimedAt)
    === getGameDayKey(Date.now() + serverTimeDelta - 24 * 60 * 60 * 1000);
  const projectedDailyLoginStreak = isYesterdayClaim ? (auth.dailyLoginRewardStreak || 0) + 1 : 1;

  // Напоминание о стартовых заданиях — самая низкоприоритетная модалка меню:
  // открывается только после всех наградных. Ежедневная награда появляется не
  // сразу (сначала сверка с сервером), поэтому очередь считается занятой и
  // пока модалка лишь может появиться — иначе напоминание успело бы мелькнуть
  // первым
  const isDailyLoginRewardQueued = isDailyLoginRewardModalOpen
    || (isDailyLoginRewardAvailable && isRewardAvailableOnServer !== false && !isDailyLoginRewardSeen);
  const isOtherRewardModalQueued = isPartnerRewardModalOpen
    || isFriendRewardModalOpen
    || isLoginPromoModalOpen
    || isDailyLoginRewardQueued;
  // Поздравление за установку приложения встает в ту же очередь: показывается,
  // когда другие наградные модалки отыграли, и сама задерживает те, что идут
  // ниже по приоритету
  const isRewardModalQueued = isOtherRewardModalQueued
    || Boolean(appInstallRewardChestId)
    || isAppInstallRewardRequestPending;

  // Кристаллы за рейтинг: непрочитанные начисления забираем один раз на
  // монтировании меню. Приоритет ниже ежедневной награды за вход, но выше
  // напоминания о заданиях (см. isRatingCrystalsQueued в его условии)
  const [ratingCrystalsRewards, setRatingCrystalsRewards] = useState([]);
  const [ratingCrystalsCurrentRating, setRatingCrystalsCurrentRating] = useState(0);
  const [isRatingCrystalsModalOpen, setRatingCrystalsModalOpen] = useState(false);
  const [isRatingCrystalsSeen, setRatingCrystalsSeen] = useState(false);
  // Пока ответ сервера не пришел, неизвестно, будет ли модалка — очередь
  // считаем занятой, иначе напоминание о заданиях выскочило бы первым
  const [isRatingCrystalsChecked, setRatingCrystalsChecked] = useState(false);

  useEffect(() => {
    if (!auth.id) return undefined;

    let isCancelled = false;
    fetch(`${API_BASE}/users/me/rating-crystals?unreadOnly=1`, {credentials: 'include'})
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
      .then((data) => {
        if (isCancelled) return;
        setRatingCrystalsRewards(data.rewards || []);
        setRatingCrystalsCurrentRating(data.currentRating ?? 0);
      })
      .catch((error) => {
        // Не критично: в следующий заход в меню попробуем снова
        console.error('Rating crystals fetch error', error);
      })
      .finally(() => {
        if (!isCancelled) {
          setRatingCrystalsChecked(true);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [auth.id]);

  // Очередь занята, пока ответ сервера не получен либо непрочитанные
  // начисления есть и игрок их не закрыл
  const isRatingCrystalsQueued = Boolean(auth.id)
    && (!isRatingCrystalsChecked || (ratingCrystalsRewards.length > 0 && !isRatingCrystalsSeen));

  // Открываем ТОЛЬКО когда точно есть что показать. isRatingCrystalsQueued
  // для этого не годится: пока ответ сервера не пришел, он истинен «на всякий
  // случай» (чтобы придержать очередь), и модалка открылась бы вхолостую —
  // пустой, но со звуком
  useEffect(() => {
    if (!isRatingCrystalsChecked || isRatingCrystalsSeen) return;
    if (ratingCrystalsRewards.length === 0) return;
    if (isRewardModalQueued || isRatingCrystalsModalOpen) return;
    setRatingCrystalsModalOpen(true);
  }, [
    isRatingCrystalsChecked, isRatingCrystalsSeen, ratingCrystalsRewards,
    isRewardModalQueued, isRatingCrystalsModalOpen,
  ]);

  // Кнопка «Отлично»: помечаем показанные записи прочитанными, чтобы в
  // следующий раз о них не напоминать
  const handleRatingCrystalsClose = (ids) => {
    setRatingCrystalsModalOpen(false);
    setRatingCrystalsSeen(true);
    fetch(`${API_BASE}/users/me/rating-crystals/read`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      credentials: 'include',
      body: JSON.stringify({ids}),
    }).catch((error) => {
      console.error('Rating crystals read error', error);
    });
  };

  // Знакомство с механикой «Кристаллы за рейтинг»: один раз на устройстве и
  // только тем, у кого рейтинг ненулевой — остальным объяснять пока нечего.
  // Приоритет ниже модалки начислений, но выше напоминания о заданиях
  const [isRatingIntroDue] = useState(() => checkIfRatingCrystalsIntroPending());
  const [isRatingIntroModalOpen, setRatingIntroModalOpen] = useState(false);
  const [isRatingIntroSeen, setRatingIntroSeen] = useState(false);
  const isRatingIntroQueued = isRatingIntroDue && Boolean(auth.rating) && !isRatingIntroSeen;

  useEffect(() => {
    if (!auth.id || !isRatingIntroQueued) return;
    if (isRewardModalQueued || isRatingCrystalsQueued || isRatingIntroModalOpen) return;
    setRatingIntroModalOpen(true);
  }, [auth.id, isRatingIntroQueued, isRewardModalQueued, isRatingCrystalsQueued, isRatingIntroModalOpen]);

  // Флаг ставится по кнопке «Отлично!», а не по факту появления: показ,
  // который игрок не закрыл (ушел со страницы, перезагрузил), не считается
  const handleRatingIntroClose = () => {
    setRatingIntroModalOpen(false);
    setRatingIntroSeen(true);
    rememberRatingCrystalsIntroShown();
  };

  // Промо-модалки для новичка — три, по ступеням воронки (см. utils/menuPromo):
  // 1) обучение пройдено, матчей нет вовсе — приглашение в бой с ботами.
  //    Сразу после первого прохождения последней главы (отметка pending — ее
  //    ставит TutorialChapterCompleteModal), а дальше, пока партий так и нет,
  //    — при заходе в меню не чаще раза в сутки;
  // 2) бой с ботами уже был, сетевых матчей нет — приглашение в обычный
  //    сетевой матч;
  // 3) сетевой матч уже был, рейтингового нет — приглашение в рейтинг. Обе
  //    следующие ступени открываются при первом же заходе в меню (счетчики
  //    матчей после партии двигаются локально, см.
  //    getOwnMatchResultProfileActions и incrementLocalGamesPlayed), дальше —
  //    не чаще раза в сутки.
  // Условия взаимоисключающие. Право на показ проверяется один раз, на
  // монтировании меню. Приоритет ниже всех наградных модалок (в том числе
  // ежедневной награды за вход) и знакомства с кристаллами за рейтинг, но
  // выше напоминания о заданиях
  const [isBotMatchPromoPending] = useState(() => checkIfBotMatchPromoPending());
  const [isBotMatchPromoDue] = useState(() => checkIfBotMatchPromoDue());
  const [isBotMatchPromoSeen, setBotMatchPromoSeen] = useState(false);
  const [isBotMatchPromoModalOpen, setBotMatchPromoModalOpen] = useState(false);
  const botMatchPromoReason = resolveBotMatchPromoReason({
    completedTutorialChapters: auth.completedTutorialChapters,
    localGamesPlayed: auth.localGamesPlayed,
    onlineGamesPlayed: auth.onlineGamesPlayed,
    isPending: isBotMatchPromoPending,
    isDue: isBotMatchPromoDue,
  });
  const isBotMatchPromoQueued = Boolean(auth.id)
    && Boolean(botMatchPromoReason)
    && !isBotMatchPromoSeen;

  const [isOnlineMatchPromoDue] = useState(() => checkIfOnlineMatchPromoDue());
  const [isOnlineMatchPromoEverShown] = useState(() => checkIfOnlineMatchPromoEverShown());
  const [isOnlineMatchPromoSeen, setOnlineMatchPromoSeen] = useState(false);
  const [isOnlineMatchPromoModalOpen, setOnlineMatchPromoModalOpen] = useState(false);
  const onlineMatchPromoReason = resolveOnlineMatchPromoReason({
    localGamesPlayed: auth.localGamesPlayed,
    onlineGamesPlayed: auth.onlineGamesPlayed,
    isDue: isOnlineMatchPromoDue,
    isEverShown: isOnlineMatchPromoEverShown,
  });
  const isOnlineMatchPromoQueued = Boolean(auth.id)
    && Boolean(onlineMatchPromoReason)
    && !isOnlineMatchPromoSeen;

  const [isRankedMatchPromoDue] = useState(() => checkIfRankedMatchPromoDue());
  const [isRankedMatchPromoEverShown] = useState(() => checkIfRankedMatchPromoEverShown());
  const [isRankedMatchPromoSeen, setRankedMatchPromoSeen] = useState(false);
  const [isRankedMatchPromoModalOpen, setRankedMatchPromoModalOpen] = useState(false);
  const rankedMatchPromoReason = resolveRankedMatchPromoReason({
    onlineGamesPlayed: auth.onlineGamesPlayed,
    rankedGamesPlayed: auth.rankedGamesPlayed,
    isDue: isRankedMatchPromoDue,
    isEverShown: isRankedMatchPromoEverShown,
  });
  const isRankedMatchPromoQueued = Boolean(auth.id)
    && Boolean(rankedMatchPromoReason)
    && !isRankedMatchPromoSeen;

  useEffect(() => {
    if (!isBotMatchPromoQueued || isBotMatchPromoModalOpen) return;
    if (isRewardModalQueued || isRatingCrystalsQueued || isRatingIntroQueued) return;
    setBotMatchPromoModalOpen(true);
  }, [
    isBotMatchPromoQueued, isBotMatchPromoModalOpen,
    isRewardModalQueued, isRatingCrystalsQueued, isRatingIntroQueued,
  ]);

  useEffect(() => {
    if (!isOnlineMatchPromoQueued || isOnlineMatchPromoModalOpen) return;
    if (isRewardModalQueued || isRatingCrystalsQueued || isRatingIntroQueued || isBotMatchPromoQueued) return;
    setOnlineMatchPromoModalOpen(true);
  }, [
    isOnlineMatchPromoQueued, isOnlineMatchPromoModalOpen,
    isRewardModalQueued, isRatingCrystalsQueued, isRatingIntroQueued, isBotMatchPromoQueued,
  ]);

  useEffect(() => {
    if (!isRankedMatchPromoQueued || isRankedMatchPromoModalOpen) return;
    if (isRewardModalQueued || isRatingCrystalsQueued || isRatingIntroQueued) return;
    if (isBotMatchPromoQueued || isOnlineMatchPromoQueued) return;
    setRankedMatchPromoModalOpen(true);
  }, [
    isRankedMatchPromoQueued, isRankedMatchPromoModalOpen,
    isRewardModalQueued, isRatingCrystalsQueued, isRatingIntroQueued,
    isBotMatchPromoQueued, isOnlineMatchPromoQueued,
  ]);

  // Отметка «обучение только что пройдено» у игрока, который уже сыграл
  // партию, бесполезна: приглашение в бой с ботами ему не покажется никогда
  // (см. resolveBotMatchPromoReason) — снимаем, чтобы не висела
  useEffect(() => {
    if (isBotMatchPromoPending && (auth.localGamesPlayed > 0 || auth.onlineGamesPlayed > 0)) {
      clearBotMatchPromoPending();
    }
  }, [isBotMatchPromoPending, auth.localGamesPlayed, auth.onlineGamesPlayed]);

  // Обе кнопки приглашения ведут сюда. Отметки ставятся только теперь, когда
  // игрок сам закрыл приглашение: показ, который он не тронул (перезагрузил
  // страницу, ушел с меню), не считается. Отметка «обучение только что
  // пройдено» снимается — дальше приглашение живет по суточному правилу
  const handleBotMatchPromoClose = () => {
    setBotMatchPromoModalOpen(false);
    setBotMatchPromoSeen(true);
    rememberBotMatchPromoShown();
    clearBotMatchPromoPending();
  };

  const handleOnlineMatchPromoClose = () => {
    setOnlineMatchPromoModalOpen(false);
    setOnlineMatchPromoSeen(true);
    rememberOnlineMatchPromoShown();
  };

  const handleRankedMatchPromoClose = () => {
    setRankedMatchPromoModalOpen(false);
    setRankedMatchPromoSeen(true);
    rememberRankedMatchPromoShown();
  };

  // Кнопки приглашений ведут в асинхронные переходы (поиск рейтинга, сбор
  // лобби, загрузка поля для боя с ботами): пока ответ не пришел, меню еще на
  // экране, и освободившуюся очередь заняло бы напоминание о заданиях — под
  // модалкой «Недостаточно фракций» или уведомлением о сбое. На этот заход
  // напоминание глушим; в localStorage оно не пишется и вернется при
  // следующем монтировании меню
  const handleRankedMatchPromoRankedGame = () => {
    setQuestsReminderShown(true);
    setRankSkinsNewsMuted(true);
    setAiMatchPromoMuted(true);
    setAiMatchNewsMuted(true);
    onRankedGame();
  };

  const handleOnlineMatchPromoFindOpponents = () => {
    setQuestsReminderShown(true);
    setRankSkinsNewsMuted(true);
    setAiMatchPromoMuted(true);
    setAiMatchNewsMuted(true);
    onFindOpponents();
  };

  const handleBotMatchPromoBattle = () => {
    setQuestsReminderShown(true);
    setRankSkinsNewsMuted(true);
    setAiMatchPromoMuted(true);
    setAiMatchNewsMuted(true);
    onBotMatch();
  };

  // Право на показ проверяется один раз, на монтировании меню: если
  // напоминание уже показывали на этом устройстве меньше суток назад, в этот
  // заход оно молчит — и дату показа не двигает
  const [isQuestsReminderDue] = useState(() => checkIfQuestsReminderDue());
  // Самый первый показ на устройстве — с приветственным текстом
  const [isQuestsReminderIntro] = useState(() => checkIfQuestsReminderIntroPending());
  const [isQuestsReminderShown, setQuestsReminderShown] = useState(false);
  const [isQuestsReminderModalOpen, setQuestsReminderModalOpen] = useState(false);
  useEffect(() => {
    if (!auth.id || !hasReminderQuests || !isQuestsReminderDue) return;
    if (isQuestsReminderShown || isRewardModalQueued || isRatingCrystalsQueued) return;
    if (isRatingIntroQueued || isBotMatchPromoQueued || isOnlineMatchPromoQueued) return;
    if (isRankedMatchPromoQueued) return;

    // Отметки в localStorage здесь НЕ ставятся: они означают, что игрок
    // напоминание увидел и закрыл (см. onClose ниже). Показ, который он
    // проигнорировал — ушел со страницы или перезагрузил ее, — не считается
    setQuestsReminderShown(true);
    setQuestsReminderModalOpen(true);
  }, [
    auth.id, hasReminderQuests, isQuestsReminderDue, isQuestsReminderShown, isRewardModalQueued,
    isRatingCrystalsQueued, isRatingIntroQueued, isBotMatchPromoQueued, isOnlineMatchPromoQueued,
    isRankedMatchPromoQueued,
  ]);

  // Витрина (демо-матч/реплей) не начинается, пока над меню висит модалка —
  // ни представления игроков, ни первого действия записи человек за ней все
  // равно не увидит. Считаем очередь занятой и когда модалка еще только
  // собирается открыться: наградные разбираются асинхронно (сверка с
  // сервером), и без этого витрина успела бы стартовать в паузе между ними.
  // Модалки, которые открываются только по клику самого игрока (вход для
  // гостя, правила, обмен кристаллов), витрину уже не останавливают — она к
  // тому моменту идет, а гасить ее на полпути значило бы отматывать запись
  // Все наградные модалки и напоминание о заданиях существуют только для
  // вошедшего игрока (их эффекты начинаются с auth.id). У гостя их очередь
  // висела бы занятой вечно: ежедневная награда «доступна» (профиль-заглушка
  // ее не забирал), а сверка с сервером, которая сняла бы флаг, не
  // запускается вовсе — витрина не начиналась бы никогда
  const isOtherMenuModalQueueBusy = Boolean(auth.id) && (
    isRewardModalQueued
    || isRatingCrystalsQueued
    || isRatingIntroQueued
    || isBotMatchPromoQueued
    || isOnlineMatchPromoQueued
    || isRankedMatchPromoQueued
    || isQuestsReminderModalOpen
    || (isQuestsReminderDue && hasReminderQuests && !isQuestsReminderShown)
  );

  // Новость о рейтинговых обличиях — самая низкоприоритетная модалка меню,
  // ниже даже напоминания о заданиях: открывается, только когда очередь
  // всех остальных свободна (isOtherMenuModalQueueBusy — в том числе пока
  // наградные еще сверяются с сервером) и поверх меню не висит ничего,
  // открытого самим игроком или App (вход для гостя, установка приложения,
  // вступительная колода). Показывается один раз на аккаунт: признак
  // показа — в профиле (см. checkIfRankSkinsNewsDue), отметку ставит закрытие
  const isRankSkinsNewsDue = checkIfRankSkinsNewsDue({
    userId: auth.id,
    isGuest,
    onlineGamesPlayed: auth.onlineGamesPlayed,
    rankedGamesPlayed: auth.rankedGamesPlayed,
    hasSeenRankSkinsNews: auth.hasSeenRankSkinsNews,
  });
  const [isRankSkinsNewsModalOpen, setRankSkinsNewsModalOpen] = useState(false);
  // Глушение на этот заход: промо-кнопки ведут в асинхронные переходы, и
  // освободившуюся очередь новость заняла бы под «Недостаточно фракций» или
  // уведомлением о сбое (см. handleRankedMatchPromoRankedGame). Отметка показа
  // при этом не ставится — новость вернется при следующем монтировании меню
  const [isRankSkinsNewsMuted, setRankSkinsNewsMuted] = useState(false);
  const isRankSkinsNewsQueued = isRankSkinsNewsDue && !isRankSkinsNewsMuted;

  useEffect(() => {
    const isOpenable = checkIfRankSkinsNewsOpenable({
      isQueued: isRankSkinsNewsQueued,
      isOpen: isRankSkinsNewsModalOpen,
      isOtherMenuModalQueueBusy,
      loginRequiredReason,
      isAppInstallPromoOpen,
      isIntroSlidesVisible,
    });
    if (isOpenable) {
      setRankSkinsNewsModalOpen(true);
    }
  }, [
    isRankSkinsNewsQueued, isRankSkinsNewsModalOpen, isOtherMenuModalQueueBusy,
    loginRequiredReason, isAppInstallPromoOpen, isIntroSlidesVisible,
  ]);

  // Обе кнопки новости ведут сюда (кнопка коллекции — еще и в переход): в
  // профиле отмечаем сразу, не дожидаясь сервера, — меню перемонтируется уже
  // при возврате из коллекции, и новость не должна всплыть снова
  const handleRankSkinsNewsClose = () => {
    setRankSkinsNewsModalOpen(false);
    dispatch(setRankSkinsNewsSeen());
    markRankSkinsNewsSeen();
  };

  const isMenuModalQueueBusy = isOtherMenuModalQueueBusy
    || (Boolean(auth.id) && isRankSkinsNewsQueued);

  // Анонс ежедневной «Битвы с AI Claude Opus» (ниже) открыт: ежедневное
  // приглашение его ждет. Объявлен заранее — приглашение проверяет его раньше,
  // чем идет сам блок анонса
  const [isAiMatchNewsModalOpen, setAiMatchNewsModalOpen] = useState(false);

  // Промо «Битвы с AI Claude Opus» — ниже всех модалок меню, даже новости о
  // рейтинговых обличиях: открывается, когда свободна очередь всех остальных
  // модалок меню, пока лобби дня ждет игроков (checkIfAiMatchPromoOpenable), и не
  // чаще раза за игровой день (отметка в localStorage, не в профиле — см.
  // aiMatchPromoStorage). Гостю тоже: «Присоединиться» ведет его в окно входа
  const [isAiMatchPromoModalOpen, setAiMatchPromoModalOpen] = useState(false);
  // Закрыта в этот заход: повторно до перемонтирования меню не открываем,
  // даже если отметка в localStorage не записалась (приватный режим)
  const [isAiMatchPromoSeen, setAiMatchPromoSeen] = useState(false);
  // Глушение на этот заход — как у новости (isRankSkinsNewsMuted): игрок ушел
  // в асинхронный переход, и промо не должно лечь поверх его исхода
  const [isAiMatchPromoMuted, setAiMatchPromoMuted] = useState(false);
  // Игровой день, в который промо открылось: отметку ставим за него, даже
  // если игрок закроет модалку уже после смены суток
  const aiMatchPromoDayKeyRef = useRef(null);

  useEffect(() => {
    const dayKey = getGameDayKey(Date.now() + serverTimeDelta);
    const isOpenable = checkIfAiMatchPromoOpenable({
      aiPromo,
      // localStorage читаем только здесь, а не на каждой перерисовке меню
      isDue: checkIfAiMatchPromoDue(dayKey),
      isOpen: isAiMatchPromoModalOpen,
      isSeen: isAiMatchPromoSeen,
      isMuted: isAiMatchPromoMuted,
      isMenuModalQueueBusy: isMenuModalQueueBusy || isRankSkinsNewsModalOpen || isAiMatchNewsModalOpen,
      loginRequiredReason,
      isAppInstallPromoOpen,
      isIntroSlidesVisible,
    });
    if (isOpenable) {
      aiMatchPromoDayKeyRef.current = dayKey;
      setAiMatchPromoModalOpen(true);
    }
  }, [
    aiPromo, serverTimeDelta, isAiMatchPromoModalOpen, isAiMatchPromoSeen, isAiMatchPromoMuted,
    isMenuModalQueueBusy, isRankSkinsNewsModalOpen, isAiMatchNewsModalOpen, loginRequiredReason,
    isAppInstallPromoOpen, isIntroSlidesVisible,
  ]);

  // Пока промо было открыто, матч начался (лобби заполнилось, пошли баны) или
  // день отменили — приглашать игроком уже некуда: закрываем без отметки
  // показа. Кнопка меню к этому времени уже зовет смотреть матч
  useEffect(() => {
    if (isAiMatchPromoModalOpen && !checkIfAiPromoJoinable(aiPromo)) {
      setAiMatchPromoModalOpen(false);
    }
  }, [isAiMatchPromoModalOpen, aiPromo]);

  // Обе кнопки промо ведут сюда («Присоединиться» — еще и во вход в лобби)
  const handleAiMatchPromoClose = () => {
    setAiMatchPromoModalOpen(false);
    setAiMatchPromoSeen(true);
    rememberAiMatchPromoShown(aiMatchPromoDayKeyRef.current);
  };

  // Разовый анонс: «Битва с AI Claude Opus» теперь каждый день и открыта всем.
  // Один раз на аккаунт и редакцию (после переноса времени матча анонс снова
  // видят все, а закрывшим прежний он говорит о новом времени —
  // auth.isAiMatchNewsUpdate) и только когда промо игроку открыто (признаки — в
  // профиле, см. checkIfAiMatchNewsDue), сразу после новости о рейтинговых
  // обличиях и не во время набора в лобби дня: тогда в матч зовет ежедневное
  // приглашение (checkIfAiMatchNewsOpenable). Отметку в профиле ставит закрытие
  const isAiMatchNewsDue = checkIfAiMatchNewsDue({
    userId: auth.id,
    isGuest,
    isAiPromoAvailable: auth.isAiPromoAvailable,
    hasSeenAiMatchNews: auth.hasSeenAiMatchNews,
  });
  // Глушение на этот заход — как у новости об обличиях: игрок ушел в
  // асинхронный переход, и анонс не должен лечь поверх его исхода
  const [isAiMatchNewsMuted, setAiMatchNewsMuted] = useState(false);
  const isAiMatchNewsQueued = isAiMatchNewsDue && !isAiMatchNewsMuted;
  const isAiPromoJoinableNow = checkIfAiPromoJoinable(aiPromo);

  // Набор в лобби дня шел в этот заход — в матч уже звало приглашение (или
  // кнопка меню). Анонс откладываем до следующего захода, а не открываем сам
  // по себе, когда лобби перестанет набирать игроков (старт матча, отмена дня):
  // «заходи в 21:00» после закрытого набора только сбивает. Уже открытый анонс
  // это не закрывает — приглашение его подождет
  useEffect(() => {
    if (isAiPromoJoinableNow) {
      setAiMatchNewsMuted(true);
    }
  }, [isAiPromoJoinableNow]);

  useEffect(() => {
    const isOpenable = checkIfAiMatchNewsOpenable({
      isQueued: isAiMatchNewsQueued,
      isOpen: isAiMatchNewsModalOpen,
      isMenuModalQueueBusy,
      isRankSkinsNewsOpen: isRankSkinsNewsModalOpen,
      isAiMatchPromoOpen: isAiMatchPromoModalOpen,
      isAiPromoJoinable: isAiPromoJoinableNow,
      isAiPromoChecked,
      loginRequiredReason,
      isAppInstallPromoOpen,
      isIntroSlidesVisible,
    });
    if (isOpenable) {
      setAiMatchNewsModalOpen(true);
    }
  }, [
    isAiMatchNewsQueued, isAiMatchNewsModalOpen, isMenuModalQueueBusy, isRankSkinsNewsModalOpen,
    isAiMatchPromoModalOpen, isAiPromoJoinableNow, isAiPromoChecked, loginRequiredReason,
    isAppInstallPromoOpen, isIntroSlidesVisible,
  ]);

  // В профиле отмечаем сразу, не дожидаясь сервера, — как у новости об обличиях
  const handleAiMatchNewsClose = () => {
    setAiMatchNewsModalOpen(false);
    dispatch(setAiMatchNewsSeen());
    markAiMatchNewsSeen();
  };

  // Кнопка меню и «Присоединиться» в промо: гостю — окно входа (в лобби с
  // ИИ пускают только с аккаунтом, даже зрителем), вошедшему — вход в лобби
  // дня. Вход асинхронный: пока ответ не пришел, промо глушим, чтобы оно не
  // открылось поверх лобби или уведомления об отказе
  const handleAiMatch = requireAuth(() => {
    if (!aiPromo?.lobbyId) return;
    setAiMatchPromoMuted(true);
    setAiMatchNewsMuted(true);
    onAiMatch?.(aiPromo.lobbyId);
  }, LOGIN_REQUIRED_REASONS.AI_MATCH);

  // Вступительная колода перекрывает меню целиком (см. App.js): витрина за
  // ней грузится, но матч не начинается — смотреть его некому. Промо с ИИ
  // приходит по ответу сервера и может открыться до старта витрины — тогда
  // и оно ее придерживает. Положенный анонс держит витрину еще до открытия
  // (как положенная новость об обличиях в isMenuModalQueueBusy): он
  // открывается эффектом, а защелка старта витрины (useUnblockedOnce)
  // сработала бы в коммите перед этим. В окне набора анонс заглушен и
  // витрину не держит
  const isAiMatchNewsPending = Boolean(auth.id) && isAiMatchNewsQueued && !isAiPromoJoinableNow;
  const isDemoBlockedByModals = isMenuModalQueueBusy
    || isAiMatchPromoModalOpen
    || isAiMatchNewsModalOpen
    || isAiMatchNewsPending
    || Boolean(loginRequiredReason)
    || Boolean(isIntroSlidesVisible);

  const isTitleVisible = useOpaqueOnMount(1000);

  usePageAnalytics('MainMenu');

  // Ключ форсирует полный ремаунт демо-партии (свежее поле/фракции/боты)
  // после того, как предыдущая партия завершилась и плавно скрылась
  const [demoGameKey, setDemoGameKey] = useState(0);
  const handleDemoGameRestart = () => setDemoGameKey((prevKey) => prevKey + 1);

  return (
    <>
      {isDesktop && (
        <MenuDemoGame
          key={demoGameKey}
          onRestartRequested={handleDemoGameRestart}
          isBlockedByModals={isDemoBlockedByModals}
        />
      )}

      {!isDesktop && (
        <UserHeader
            pageId={'MainMenu'}
            onGoToCrystals={onGoToCrystals}
            onDevLogin={onDevLogin}
            onEmailAuthSuccess={onEmailAuthSuccess}
          />
      )}

      <div className={`main-menu-content ${isDesktop ? 'main-menu-left-panel' : undefined}`}>
        {isDesktop && (
          <UserHeader
            pageId={'MainMenu'}
            onGoToCrystals={onGoToCrystals}
            onDevLogin={onDevLogin}
            onEmailAuthSuccess={onEmailAuthSuccess}
          />
        )}

        {isDesktop &&
          <div className={'main-menu-title-desktop'}>
            <LoadedImage
              className={'main-menu-bust_with-balance'}
              src={'/img/other/strategikon_bust.png'}
            />
            <h1 className={`main-menu-title${isTitleVisible ? ' main-menu-title_visible' : ''}`}>Стратегикон</h1>
          </div>
        }

        {/* На узком экране витрина занимает место бюста и заголовка: показать
            живую партию важнее, чем еще раз назвать игру по имени */}
        {!isDesktop && (
          <MenuDemoGame
            key={demoGameKey}
            onRestartRequested={handleDemoGameRestart}
            isBlockedByModals={isDemoBlockedByModals}
          />
        )}


        <div className="main-menu-buttons">
          {/* После прохождения всех глав обучения кнопка становится входом в
              будущую сюжетную кампанию (конструктор миссий) — та же страница
              списка миссий */}
          <PageButton
            className={'main-menu-button_tutorial'}
            onClick={requireAuth(onTutorial, LOGIN_REQUIRED_REASONS.TUTORIAL)} pageId="MainMenu" buttonId="tutorial" isGuest={isGuest}
          >
            <span className={`main-menu-button_tutorial-label${isAllTutorialCompleted ? '' : ' main-menu-button_tutorial-label_with-icon'}`}>
              {isAllTutorialCompleted ? 'Сюжетная кампания' : 'Обучение'}
            </span>
            {!isAllTutorialCompleted && (
              /* Один статичный текст без карусели (пульс самого бейджа
                 остается) */
              <span className="main-menu-double-reward-badge">
                <span>Награды</span>
              </span>
            )}
          </PageButton>
          {/* Сразу над рейтинговым матчем; есть, только пока лобби дня с ИИ
              существует и матч не сыгран */}
          <AiMatchMenuButton
            aiPromo={aiPromo}
            serverTimeDelta={serverTimeDelta}
            isGuest={isGuest}
            onClick={handleAiMatch}
          />
          {/* Открывает экран настройки поиска (App), а не сам поиск */}
          <RankedMatchButton
            label="Рейтинговый матч"
            onClick={requireAuth(onRankedGame, LOGIN_REQUIRED_REASONS.MATCH)}
            pageId="MainMenu" buttonId="ranked_game" isGuest={isGuest}
          />
          <PageButton
            className="main-menu-button_online-game main-menu-button_with-hint"
            onClick={onNetworkGame}
            pageId="MainMenu"
            buttonId="network_game" isGuest={isGuest}
          >
            <span className="main-menu-button_label">Обычный матч</span>
            <span className="main-menu-button_hint">
              Игроков в поиске: <span className="text-attention">{onlineSearchingCount}</span>
            </span>
          </PageButton>
          <PageButton
            className="main-menu-button_local-game"
            onClick={requireAuth(onHotSeatGame, LOGIN_REQUIRED_REASONS.MATCH)} pageId="MainMenu" buttonId="local_game" isGuest={isGuest}
          >Против ботов</PageButton>
          <PageButton
            className="main-menu-button_glory-hall"
            onClick={onGloryHall} pageId="MainMenu"
            buttonId="glory_hall" isGuest={isGuest}
          >Зал славы</PageButton>
          <PageButton
            className="main-menu-button_best-collections"
            onClick={onBestCollections} pageId="MainMenu"
            buttonId="best_collections" isGuest={isGuest}
          >Лучшие коллекции</PageButton>
          <PageButton
            className={`main-menu-button_inventory${auth.isNewItems ? ' main-menu-button_inventory--new' : ''}`}
            onClick={requireAuth(onInventory, LOGIN_REQUIRED_REASONS.INVENTORY)} pageId="MainMenu" buttonId="inventory" isGuest={isGuest}
          >Моя Коллекция</PageButton>
          <PageButton
            className={`main-menu-button_profile${hasIncompleteQuests ? ' main-menu-button_profile--quests' : ''}`}
            onClick={requireAuth(onProfile, LOGIN_REQUIRED_REASONS.PROFILE)} pageId="MainMenu" buttonId="profile" isGuest={isGuest}
          >Мой Профиль</PageButton>
          <PageButton
            className={`main-menu-button_shop${HAS_DISCOUNTED_FACTIONS ? ' main-menu-button_shop--discounted' : ''}`}
            onClick={requireAuth(onShop, LOGIN_REQUIRED_REASONS.SHOP)} pageId="MainMenu" buttonId="shop" isGuest={isGuest}
          >Магазин</PageButton>
          <PageButton
            className={'main-menu-button_secondary main-menu-button_rules'}
            onClick={onRules} pageId="MainMenu" buttonId="rules" isGuest={isGuest}
          >Правила</PageButton>

          {/* Установка приложения: кнопка есть только там, где браузер
              действительно умеет ставить PWA по нашему запросу, и пока
              награда за первый вход через приложение не получена — бейдж
              обещает именно ее */}
          {isAppInstallAvailable && (
            <PageButton
              className={'main-menu-button_secondary main-menu-button_app-install'}
              onClick={() => setAppInstallPromoOpen(true)}
              pageId="MainMenu" buttonId="app_install" isGuest={isGuest}
            >
              Установить приложение
              {!auth.appInstallRewardGrantedAt && (
                <span className="main-menu-double-reward-badge">
                  <span>Награда</span>
                </span>
              )}
            </PageButton>
          )}
          <PageButton
            className={'main-menu-button_secondary'}
            onClick={onSettings} pageId="MainMenu" buttonId="settings" isGuest={isGuest}
          >Настройки</PageButton>
          {auth.isAdmin && (
            <PageButton
              className={'main-menu-button_secondary'}
              onClick={onAdmin} pageId="MainMenu" buttonId="admin"
            >Админка</PageButton>
          )}
          {auth.isActivePartner && (
            <PageButton
              className={'main-menu-button_secondary'}
              onClick={onPartner} pageId="MainMenu" buttonId="partner"
            >Партнерка</PageButton>
          )}
        </div>

        <div className="main-menu-footer">
          <MainMenuSocialLinks isGuest={isGuest}/>
          <div className="main-menu-footer_row">
            <PageButton
              className="main-menu-footer_link"
              onClick={onContacts} pageId="MainMenu" buttonId="contacts"
            >Контакты</PageButton>
            <PageButton
              className="main-menu-footer_link"
              onClick={onAcknowledgments} pageId="MainMenu" buttonId="acknowledgments"
            >Благодарности</PageButton>
          </div>
          <div className="main-menu-footer_row">
            <PageButton
              className="main-menu-footer_link"
              onClick={onLicenseAgreement} pageId="MainMenu" buttonId="license_agreement"
            >Лицензионное соглашение</PageButton>
          </div>
          <div className="main-menu-footer_row">
            <PageButton
              className="main-menu-footer_link"
              onClick={onPrivacyPolicy} pageId="MainMenu" buttonId="privacy_policy"
            >Политика конфиденциальности</PageButton>
          </div>
          <div className="main-menu-footer_copyright">
            {`™ Стратегикон, ${new Date().getFullYear()}, все права защищены`}
          </div>
          <VersionLabel className="main-menu-version"/>
        </div>
      </div>

      {isPartnerRewardModalOpen && (
        <PartnerReferalRewardModal
          onClose={() => setPartnerRewardModalHidden(true)}
          onUnavailable={() => setPartnerRewardModalHidden(true)}
          onOpenPartnerProfile={onOpenUserProfile}
        />
      )}

      {isFriendRewardModalOpen && (
        <PartnerReferalRewardModal
          onClose={() => setFriendRewardModalHidden(true)}
          onUnavailable={() => setFriendRewardModalHidden(true)}
          onOpenPartnerProfile={onOpenUserProfile}
          offerEndpoint="/friend-referal-offer"
          claimEndpoint="/friend-referal-rewards/claim"
          applyClaimAction={applyFriendReferalRewardsClaim}
        />
      )}

      {isLoginPromoModalOpen && (
        <LoginPromoRewardModal
          onClose={() => setLoginPromoModalHidden(true)}
          onUnavailable={() => setLoginPromoModalHidden(true)}
        />
      )}

      {isDailyLoginRewardModalOpen && !isPartnerRewardModalOpen && !isFriendRewardModalOpen
        && !isLoginPromoModalOpen && (
        <DailyLoginRewardModal
          projectedStreak={projectedDailyLoginStreak}
          onClose={() => {
            setDailyLoginRewardModalOpen(false);
            setDailyLoginRewardSeen(true);
          }}
          onGoToCrystals={onGoToCrystals}
          onOpenInventory={onInventory}
        />
      )}

      {isRatingCrystalsModalOpen && (
        <RatingCrystalsRewardModal
          rewards={ratingCrystalsRewards}
          currentRating={ratingCrystalsCurrentRating}
          onClose={handleRatingCrystalsClose}
        />
      )}

      {isRatingIntroModalOpen && (
        <RatingCrystalsInfoModal onClose={handleRatingIntroClose}/>
      )}

      {isAppInstallPromoOpen && (
        <AppInstallPromoModal
          onInstall={handleAppInstallClick}
          isGuest={isGuest}
          onClose={() => setAppInstallPromoOpen(false)}
        />
      )}

      {appInstallRewardChestId && !isOtherRewardModalQueued && (
        <AppInstallRewardModal
          chestId={appInstallRewardChestId}
          onOpenInventory={() => {
            setAppInstallRewardChestId(null);
            onInventory();
          }}
          onClose={() => setAppInstallRewardChestId(null)}
        />
      )}

      {/* Кнопки матчей — те же обработчики, что у кнопок «Обычный матч» и
          «Рейтинговый матч» самого меню; приглашения видит только вошедший
          игрок (auth.id), так что обертка requireAuth им не нужна */}
      {isBotMatchPromoModalOpen && (
        <BotMatchPromoModal
          reason={botMatchPromoReason}
          isRewardAvailable={Boolean(getLocalMatchQuestReward(auth.completedQuests))}
          onBotMatch={handleBotMatchPromoBattle}
          onClose={handleBotMatchPromoClose}
        />
      )}

      {isOnlineMatchPromoModalOpen && (
        <OnlineMatchPromoModal
          reason={onlineMatchPromoReason}
          firstOnlineMatchReward={getOnlineMatchQuestReward(auth.availableFactions, auth.completedQuests)}
          onFindOpponents={handleOnlineMatchPromoFindOpponents}
          onClose={handleOnlineMatchPromoClose}
        />
      )}

      {isRankedMatchPromoModalOpen && (
        <RankedMatchPromoModal
          reason={rankedMatchPromoReason}
          onRankedGame={handleRankedMatchPromoRankedGame}
          onClose={handleRankedMatchPromoClose}
        />
      )}

      {loginRequiredReason && (
        <LoginRequiredModal
          reason={loginRequiredReason}
          onClose={() => setLoginRequiredReason(null)}
          onDevLogin={onDevLogin}
          onEmailAuthSuccess={onEmailAuthSuccess}
        />
      )}

      {isQuestsReminderModalOpen && (
        <QuestsReminderModal
          isIntro={isQuestsReminderIntro}
          onGoToQuests={onQuests}
          onClose={() => {
            // Игрок закрыл напоминание сам — кнопкой «Задания», «Скрыть» или
            // кликом по фону (все три пути ведут сюда). Только теперь суточная
            // пауза начинается, а приветственный текст считается показанным
            rememberQuestsReminderShown();
            rememberQuestsReminderIntroShown();
            setQuestsReminderModalOpen(false);
          }}
        />
      )}

      {isRankSkinsNewsModalOpen && (
        <RankSkinsNewsModal
          onOpenCollection={onInventoryRankSkins}
          onClose={handleRankSkinsNewsClose}
        />
      )}

      {isAiMatchNewsModalOpen && (
        <AiMatchNewsModal
          isUpdate={auth.isAiMatchNewsUpdate}
          serverTimeDelta={serverTimeDelta}
          onClose={handleAiMatchNewsClose}
        />
      )}

      {isAiMatchPromoModalOpen && (
        <AiMatchPromoModal
          aiPromo={aiPromo}
          serverTimeDelta={serverTimeDelta}
          onJoin={handleAiMatch}
          onClose={handleAiMatchPromoClose}
        />
      )}
    </>
  );
}

export default MainMenu;
